import { useState, useEffect } from 'react'
import { validarTexto } from '../../helpers/textFormatHelpers.js'
import * as domiciliosService from '../servicios/domiciliosService.js'

const esDomicilioCompleto = (domicilio) =>
  Boolean(domicilio) &&
  validarTexto(domicilio.calle) &&
  validarTexto(domicilio.calleAltura) &&
  validarTexto(domicilio.localidad) &&
  validarTexto(domicilio.provincia)

export const useDomicilioPrincipalEBM = (idUsuario) => {
  const [resultado, setResultado] = useState({ idUsuario: null, domicilio: null, error: false })

  useEffect(() => {
    if (!idUsuario) return

    let cancelado = false

    const obtenerDomicilio = async () => {
      let domicilioValidado = null
      let error = false
      try {
        const respuesta = await domiciliosService.buscarDomicilioPrincipal({ idUsuario })
        const domicilio = respuesta?.data?.body?.domicilio
        domicilioValidado = esDomicilioCompleto(domicilio) ? domicilio : null
      } catch {
        error = true
      }
      if (!cancelado) {
        setResultado({ idUsuario, domicilio: domicilioValidado, error })
      }
    }

    obtenerDomicilio()

    return () => {
      cancelado = true
    }
  }, [idUsuario])

  const domicilioEBMResuelto = Boolean(idUsuario) && resultado.idUsuario === idUsuario
  const domicilioPrincipalEBM = domicilioEBMResuelto ? resultado.domicilio : null

  return {
    domicilioPrincipalEBM,
    domicilioEBMEstaCompleto: Boolean(domicilioPrincipalEBM),
    domicilioEBMResuelto,
    errorDomicilioEBM: domicilioEBMResuelto && resultado.error
  }
}
